(function () {
  angular
    .module("akitabox.ui.dialogs.document.select")
    .service("SelectDocumentDialog", SelectDocumentDialog);

  /* @ngInject */
  function SelectDocumentDialog($q, $log, $mdDialog, $mdMedia) {
    var modal = {
      templateUrl:
        "app/core/ui/dialogs/document/select/select-file.dialog.html",
      controller: "SelectDocumentDialogController",
      controllerAs: "dialog",
      bindToController: true,
      parent: angular.element(document.body),
      closeTo: angular.element(document.body),
      clickOutsideToClose: false,
      focusOnOpen: false,
    };

    // Enable fullscreen mode while on mobile
    if ($mdMedia("sm") || $mdMedia("xs")) {
      modal.fullscreen = true;
    }

    var service = {
      show: show,
    };

    return service;

    // ------------------------
    //   Public Functions
    // ------------------------

    /**
     * Show select document dialog. `options.locals.building` is required
     *
     * @param  {Object}  options                       Dialog options
     * @param  {Object}  options.locals                Dialog options
     * @param  {Object}  options.locals.building       A building model
     * @param  {Array}   options.locals.tagCategories  An array of tag categories in a building
     * @param  {Boolean} [options.locals.followLink]   When false, stops clicks on the document thumbnail
     *    from opening document in a new tab.
     *
     * @return  {Promise<Object|Error>}  Promise that resolves with the selected document
     */
    function show(options) {
      if (!options || !options.locals || !options.locals.building) {
        $log.error("SelectDocumentDialog: no building local provided");
        return $q.reject("Sorry, we weren't able to complete your request.");
      } else if (!options || !options.locals || !options.locals.tagCategories) {
        $log.error("SelectDocumentDialog: no tag categories local provided");
        return $q.reject("Sorry, we weren't able to complete your request.");
      }
      var dialogOptions = angular.extend({}, modal, options);
      return $mdDialog.show(dialogOptions);
    }
  }
})();
